// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"cq-z","imageAndVideoCount":"dq-z","imageAndVideoContainer":"eq-z","viewAllReviews":"fq-z"};